import { render, staticRenderFns } from "./ModalAddTemplate.vue?vue&type=template&id=04db55a8&"
import script from "./ModalAddTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalAddTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports